export const ROUTES = {
	HOME: '/',
	AUTHENTICATE: '/authenticate',
	CONTACT_US: '/contact-us',
	PRIVACY: '/privacy',
	TERMS_AND_CONDITIONS: '/terms-of-service',
	HIRING_IN_THE_PHILIPPINES: '/hiring-in-the-philippines',
	END_TO_END_RECRUITMENT: '/end-to-end-recruitment',
	FAQ: '/faq',
	ABOUT_US: '/about',
	HOW_IT_WORKS: '/how-it-works-employer',
	HOW_IT_WORKS_JOB_SEEKER: '/how-it-works-job-seeker',
	SALARY_GUIDE: '/salary',
	EMPLOYER_OF_RECORD: '/employer-of-record',
	PRICING: '/pricing',
	BROWSE_JOBS: '/find-jobs',
	ROLE: '/role/:roleName',
	AI_CANDIDATE_FEEDBACK: '/ai-candidate-feedback',

	ROLE_PAGE: {
		SECURITY_ANALYST: '/role/security-analyst',
		VIRTUAL_ASSISTANT: '/role/virtual-assistant',
		VIDEO_EDITOR: '/role/video-editor',
		SOCIAL_MEDIA_MANAGER: '/role/social-media-manager',
	},

	RESOURCES_PAGES: {
		RESOURCES: '/resources',
		ARTICLES: {
			FOR_JOB_SEEKERS: '/resources/for-job-seekers/:articleName',
			FOR_EMPLOYERS: '/resources/for-employers/:articleName',
		},
	},

	HR_PAGES: {
		HR_LANDING: '/hr',
		HR_ABOUT: '/hr/about',
		HR_PRICING: '/hr/pricing',
		HR_FAQ: '/hr/faq',
		HR_CONTACT: '/hr/contact',
		HR_TERMS: '/hr/terms',
		HR_PRIVACY: '/hr/privacy',
		HR_LEGAL: '/hr/legal',
	},

	// Not included in sitemap //////////////////////////////
	RESET_PASSWORD: '/reset-password',
	RESET_PASSWORD_CONFIRM: '/reset-password-confirm/:uidb64/:token',
	CREATE_CONTRACT: '/create-contract/:applicationId',
	CONTRACT_SUCCESS: '/contract-success',
	APPLICANTS: '/applicants/:jobId',
	USER_PROFILE: '/profile-page/:userId',
	EDIT_JOB: '/edit-job/:jobId',
	DRAFT_JOB: '/draft-job/:jobId',
	DRAFT_JOB_PREVIEW: '/draft-job-preview/:jobId',
	NOT_FOUND: '/not-found',
	BLOG: '/blog',
	BLOG_POST: '/:slug',
	EMAIL_VERIFY: '/email-verify/:email',
	EOR_VERIFICATION: '/verification',
	POST_JOB: '/postjob',
	EDIT_PROFILE: '/my-profile',
	EOR_DASHBOARD: '/eor-dashboard',
	DASHBOARD: '/dashboard',
	MY_PROFILE: '/my-profile',
	JOB_PAGE: '/job/:jobId',
	CONFIRM_EMAIL: '/confirmemail',
	ACCOUNT_SUBSCRIPTION: '/account-subscription',
	SETUP_TWO_FACTOR: '/setup-two-factor',
	JOB_PREFERENCE: '/preferences',
};

export const EXTERNAL_ROUTES = {
	FACEBOOK: 'https://www.facebook.com/profile.php?id=100085243007121',
	INSTAGRAM: 'https://www.instagram.com/permworks/',
	LINKEDIN: 'https://www.linkedin.com/company/permworks/',
	TIKTOK: 'https://www.tiktok.com/@permworks',
	PERMHUNT: 'https://permhunt.com/',
	CALENDLY_PERMHUNT: 'https://calendly.com/d/3dy-kf9-3x3/discovery-call',
	HR_DASHBOARD: 'https://hr.permworks.com/',
};

export const ADMIN_ROUTES = {
	ADMIN: '/admin',
	ADMIN_LOGS: '/admin/logs',
};
